// extracted by mini-css-extract-plugin
module.exports = {"cash-card-button":"styles_cash-card-button__jdL1I","onboarding-button":"styles_onboarding-button__kq_gj"};